import React, { memo } from 'react';
import {
  TitleContainer,
  Title,
  Description,
  ContentContainer,
  Media
} from 'app/pages/Survey/Subject/elements';
import QuoteIcon from './QuoteIcon';
import * as styles from './styles';

function Quote() {
  return (
    <>
      <TitleContainer>
        <QuoteIcon />
        <Title />
        <Description />
      </TitleContainer>
      <ContentContainer>
        <Media className={styles.quoteMedia} />
      </ContentContainer>
    </>
  );
}

export default memo(Quote);
